import React, { useState, useEffect } from 'react';
import { Card, CardHeader, CardTitle } from 'components/shadcn/ui/card';
import { HGTable } from 'components/HGTable';
import { columns } from './columns';
import { useGetWarranties, PAGE_SIZE } from './helper';
import DateSearchInput from './DateSearchInput';

const DATE_FILTER_COLUMNS = ['WarrantyStart', 'WarrantyEnd'];

const WarrantyList = () => {
    const searchSetting = JSON.parse(sessionStorage.getItem('searchSettings'));
    const [search, setSearch] = useState('');
    const [filterBy, setFilterBy] = useState(() => searchSetting?.warranties?.filterBy ?? '');
    const [currentPage, setCurrentPage] = useState(1);
    const [sortField, setSortField] = useState(() => searchSetting?.warranties?.sort ?? '');
    const [sortDirection, setSortDirection] = useState(-1);
    const {
        data: warranties,
        isFetching,
        error,
    } = useGetWarranties(
        sortDirection,
        sortField,
        currentPage,
        search,
        filterBy
    );

    useEffect(() => {
        const lastFilter = JSON.parse(sessionStorage.getItem('searchSettings')) ?? {};
        sessionStorage.setItem('searchSettings', JSON.stringify({ ...lastFilter, warranties: { filterBy, sort: sortField } }));
    }, [filterBy, sortField]);

    return (
        <Card>
            <CardHeader>
                <CardTitle>Warranty List</CardTitle>
            </CardHeader>
            <HGTable
                columns={columns ?? []}
                data={warranties?.results ?? []}
                loading={isFetching}
                skeletonRows={20}
                error={error}
                search={search}
                canSearch={true}
                canFilter={true}
                setSearch={setSearch}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={PAGE_SIZE}
                totalItems={warranties?.total ?? 0}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                sortField={sortField}
                setSortField={setSortField}
                onSearchChange={(value) => {
                    setSearch(value);
                    setCurrentPage(1);
                }}
                renderSearchInput={
                    DATE_FILTER_COLUMNS.includes(filterBy)
                        ? () => (
                              <DateSearchInput
                                  value={search}
                                  onSearchChange={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                  }}
                                  placeholder={`Search by ${filterBy === 'WarrantyStart' ? 'start' : 'end'} date...`}
                              />
                          )
                        : null
                }
            />
        </Card>
    );
};

export default WarrantyList;
